function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.298 12.156c-.583-1.23-.99-2.436-.112-3.45.262-.304.63-.694 1.103-1.172l.375-.375c.329-.325.7-.686 1.11-1.08a1.056 1.056 0 011.478.016l3.522 3.522a1.056 1.056 0 010 1.493l-1.48 1.48c1.342 1.624 2.54 2.965 3.593 4.024 1.057 1.052 2.398 2.25 4.022 3.593h0l1.48-1.48a1.056 1.056 0 011.494 0h0l3.522 3.521c.406.406.413 1.062.016 1.477-.394.412-.755.782-1.08 1.111l-.375.375c-.478.474-.868.841-1.171 1.103-1.015.878-2.221.471-3.45-.112-1.23-.584-2.129-.829-7.697-6.397l.047.047c-5.568-5.568-5.813-6.467-6.397-7.696z",
  stroke: "#000",
  strokeWidth: 1.8,
  fill: "none",
  fillRule: "evenodd"
});

function SvgUiPhone32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _ref);
}

export default SvgUiPhone32;